export default __webpack_public_path__ + "static/media/group-6507.5e495ff1.svg";